import type * as models from './models'

/** State owned by the Sibling Users feature. */
export interface State {
  users?: State.Entry<readonly models.User[]>
}
export namespace State {
  export const INITIAL: Readonly<State> = {}

  export type Entry<T> = ExactlyOneOf<{
    data?: T
    isLoading?: boolean
    error?: Error
  }>
}
